/**
 * Guarda o token do convite quando o convidado ainda não está logado, para que, após entrar/cadastrar,
 * a app volte à página de aceite em vez do dashboard. sessionStorage (não localStorage): é efêmero e
 * some ao fechar a aba. Não é segredo de longo prazo — é single-use e some no aceite.
 */
const PENDING_INVITE_KEY = 'codout.pendingInvite'

export function storePendingInvite(token: string): void {
  try {
    sessionStorage.setItem(PENDING_INVITE_KEY, token)
  } catch {
    // sessionStorage indisponível (modo privado antigo): sem retorno automático, só perde a conveniência.
  }
}

/** Lê e REMOVE o token pendente (single-use). */
export function consumePendingInvite(): string | null {
  try {
    const token = sessionStorage.getItem(PENDING_INVITE_KEY)
    if (token !== null) {
      sessionStorage.removeItem(PENDING_INVITE_KEY)
    }
    return token
  } catch {
    return null
  }
}
